import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Home: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#000',
    color: '#fff',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    {/* Main Container */}
    <div
      className="container"
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        maxWidth: 1200,
        margin: '0 auto',
        padding: '48px 32px 0 32px'
      }}
    >
      <div
        className="main-title"
        style={{
          fontSize: '3rem',
          fontWeight: 700,
          marginBottom: 32,
          lineHeight: 1.2
        }}
      >
        This domain and website are used by the company Velours, to conduct simulation exercises for organizations. All information contained on this website is purposefully fake.
      </div>
      <div
        className="main-desc"
        style={{
          fontSize: '2.2rem',
          fontWeight: 700,
          marginBottom: 48,
          lineHeight: 1.2
        }}
      >
        Please visit Velours' website and contact us for more information:<br />
        <a
          className="main-link"
          href="https://velours.com"
          target="_blank"
          rel="noopener"
          style={{
            fontSize: '2rem',
            fontWeight: 700,
            color: '#fff',
            textDecoration: 'none',
            marginTop: 32,
            display: 'inline-block',
            transition: 'color 0.2s'
          }}
          onMouseOver={e => (e.currentTarget.style.color = '#00e0ff')}
          onMouseOut={e => (e.currentTarget.style.color = '#fff')}
        >
          Click here
        </a>
      </div>
    </div>
    <Footer />
  </div>
);

export default Home;